import { render, staticRenderFns } from "./BillProfile.vue?vue&type=template&id=034aae30"
import script from "./BillProfile.vue?vue&type=script&lang=js"
export * from "./BillProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports